//вспомогательные функции брифинга

export const ac_disable = (briefing) => {

    if (briefing.no_vat === 1 && !briefing.vat && briefing.contract_type === 3) return false;

    return true;
};